import { defineComponent, h } from 'vue'
import { QChip } from 'quasar'

/**
 * A small square chip, for labelling a row. Presentational only — it extended the bundle's base for
 * nothing: no validation, no auto-save, not even a slot.
 */
export default defineComponent({
  name: 'BsTag',

  props: {
    label: { type: String, default: void 0 },
    icon: { type: String, default: void 0 },
    textColor: { type: String, default: void 0 }
  },

  render (): any {
    return h(QChip, {
      class: 'bs-tag',
      label: this.label,
      icon: this.icon,
      square: true,
      size: '8px',
      textColor: this.textColor
    })
  }
})
